// extracted by mini-css-extract-plugin
export default {"buttonPrimary":"Button_buttonPrimary__gvU2E","buttonSecondary":"Button_buttonSecondary__BMBuL","cssRipple":"Button_cssRipple__6noYA"};